/* Emma & Rose London – eigen cart drawer (vervangt Upcart) */
(function () {
  'use strict';
  if (window.ERLCart) return;

  var CFG = window.ERL_CART_CONFIG || {};
  var TIERS = (CFG.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
  var TIMER_MIN = CFG.timerMinutes || 10;
  var root = document.getElementById('ErlCart');
  if (!root) return;
  // direct onder <body> zetten zodat sticky headers de drawer niet beïnvloeden
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var els = {
    panel: root.querySelector('.erl-cart__panel'),
    logo: root.querySelector('[data-erl-logo]'),
    timer: root.querySelector('[data-erl-timer]'),
    timerVal: root.querySelector('[data-erl-timer-value]'),
    tiers: root.querySelector('[data-erl-tiers]'),
    items: root.querySelector('[data-erl-items]'),
    empty: root.querySelector('[data-erl-empty]'),
    footer: root.querySelector('[data-erl-footer]'),
    discounts: root.querySelector('[data-erl-discounts]'),
    discountTags: root.querySelector('[data-erl-discount-tags]'),
    discountAmount: root.querySelector('[data-erl-discount-amount]'),
    checkout: root.querySelector('[data-erl-checkout]')
  };

  var state = { cart: null, open: false, lastFocus: null, refreshing: null };
  var productCache = {};
  var nativeFetch = window.fetch.bind(window);

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CFG.currency || 'GBP' }).format(v);
    } catch (e) {
      return '£' + v.toFixed(2);
    }
  }
  var decoder = document.createElement('textarea');
  function decode(s) { decoder.innerHTML = s == null ? '' : String(s); return decoder.value; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function store(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }
  function api(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-ERL-Cart': '1' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return nativeFetch(url, opts).then(function (r) { return r.json(); });
  }

  var TAG_SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M10.3 2H17a1 1 0 0 1 1 1v6.7a1 1 0 0 1-.3.7l-7.6 7.6a1 1 0 0 1-1.4 0L2 11.3a1 1 0 0 1 0-1.4l7.6-7.6a1 1 0 0 1 .7-.3ZM14 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/></svg>';
  var TRASH_SVG = '<svg width="14" height="16" viewBox="0 0 14 16" aria-hidden="true"><path fill="currentColor" d="M5 1h4l1 1h3v2H1V2h3l1-1Zm-3 4h10l-.8 10H2.8L2 5Zm3 2v6h1V7H5Zm3 0v6h1V7H8Z"/></svg>';

  /* ---------- logo uit de header ---------- */
  function setLogo() {
    var img = document.querySelector('.header__heading-logo, .header__heading img, header img');
    if (img && (img.currentSrc || img.src)) {
      els.logo.innerHTML = '<img src="' + esc(img.currentSrc || img.src) + '" alt="' + esc(img.alt || '') + '">';
    }
  }

  /* ---------- timer ---------- */
  var timerInt = null;
  function timerEnd() {
    var end = parseInt(store('erl_cart_timer_end'), 10);
    var now = Date.now();
    if (!end || end <= now) {
      end = now + TIMER_MIN * 60 * 1000;
      store('erl_cart_timer_end', String(end));
    }
    return end;
  }
  function tick() {
    var left = timerEnd() - Date.now();
    var s = Math.max(0, Math.floor(left / 1000));
    var m = Math.floor(s / 60);
    els.timerVal.textContent = (m < 10 ? '0' : '') + m + ':' + (s % 60 < 10 ? '0' : '') + (s % 60);
  }
  function startTimer() { tick(); if (!timerInt) timerInt = setInterval(tick, 1000); }
  function stopTimer() { clearInterval(timerInt); timerInt = null; }

  /* ---------- kortingsbalk ---------- */
  function renderTiers(count) {
    if (!TIERS.length) { els.tiers.hidden = true; return; }
    var next = null;
    for (var i = 0; i < TIERS.length; i++) { if (count < TIERS[i].qty) { next = TIERS[i]; break; } }
    var text;
    if (next) {
      var need = next.qty - count;
      text = 'Add ' + need + ' more item' + (need > 1 ? 's' : '') + ' to get <strong>' + next.pct + '% off</strong> your order';
    } else {
      text = 'Congrats! You unlocked <strong>' + TIERS[TIERS.length - 1].pct + '% off</strong> your order';
    }
    var html = '<p class="erl-cart__tiers-text">' + text + '</p><div class="erl-cart__track-wrap"><div class="erl-cart__track">';
    var prev = 0;
    TIERS.forEach(function (t) {
      var fill = Math.max(0, Math.min(1, (count - prev) / (t.qty - prev)));
      html += '<div class="erl-cart__seg"><i style="width:' + (fill * 100) + '%"></i></div>';
      html += '<div class="erl-cart__node' + (count >= t.qty ? ' is-done' : '') + '">' + TAG_SVG.replace('fill="currentColor"', '') + '<span>' + t.pct + '% OFF</span></div>';
      prev = t.qty;
    });
    html += '</div></div>';
    els.tiers.innerHTML = html;
    els.tiers.hidden = false;
  }

  /* ---------- vergelijkprijzen (compare-at) ophalen ---------- */
  var productData = {};
  function loadCompare(items) {
    return Promise.all(items.map(function (it) {
      var h = it.handle;
      if (!h) return null;
      if (!productCache[h]) {
        productCache[h] = nativeFetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { productData[h] = d; return d; })
          .catch(function () { return null; });
      }
      return productCache[h];
    }));
  }
  function compareAt(item) {
    var data = productData[item.handle];
    if (!data || !data.variants) return 0;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === item.variant_id) return data.variants[i].compare_at_price || 0;
    }
    return 0;
  }

  /* ---------- items ---------- */
  function itemHTML(it) {
    var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title' || o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join('<br>');
    if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
      opts += (opts ? '<br>' : '') + esc(it.selling_plan_allocation.selling_plan.name);
    }
    var props = it.properties || {};
    Object.keys(props).forEach(function (k) {
      if (k.charAt(0) === '_' || props[k] === '' || props[k] == null) return;
      opts += (opts ? '<br>' : '') + esc(k) + ': ' + esc(props[k]);
    });

    var line = it.original_line_price;
    var cmp = compareAt(it) * it.quantity;
    var priceHTML = '';
    if (cmp > line) priceHTML += '<s>' + money(cmp) + '</s>';
    priceHTML += '<span>' + money(line) + '</span>';
    if (cmp > line) priceHTML += '<span class="erl-cart__save">(Save ' + money(cmp - line) + ')</span>';

    var title = esc(decode(it.product_title));
    var img = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;

    return '<div class="erl-cart__item" data-key="' + esc(it.key) + '">' +
      '<a href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(sized(img, 240)) + '" alt="' + title + '" loading="lazy" width="88" height="88">' : '') + '</a>' +
      '<div>' +
        '<div class="erl-cart__item-top">' +
          '<a class="erl-cart__item-title" href="' + esc(it.url) + '">' + title + '</a>' +
          '<button type="button" class="erl-cart__remove" data-erl-remove aria-label="Remove ' + title + '">' + TRASH_SVG + '</button>' +
        '</div>' +
        (opts ? '<p class="erl-cart__opts">' + opts + '</p>' : '') +
        '<div class="erl-cart__item-bottom">' +
          '<div class="erl-cart__qty">' +
            '<button type="button" data-erl-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" min="0" inputmode="numeric" value="' + it.quantity + '" data-erl-qty-input aria-label="Quantity">' +
            '<button type="button" data-erl-qty="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<div class="erl-cart__price">' + priceHTML + '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* ---------- render ---------- */
  function render(cart) {
    state.cart = cart;
    var count = cart.item_count || 0;
    var empty = count === 0;

    els.empty.hidden = !empty;
    els.footer.hidden = empty;
    els.timer.hidden = empty;
    if (empty) {
      els.items.innerHTML = '';
      els.tiers.hidden = true;
      return;
    }
    renderTiers(count);
    els.items.innerHTML = cart.items.map(itemHTML).join('');

    // kortingen
    var titles = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (titles.indexOf(d.title) < 0) titles.push(d.title); });
    cart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var t = a.discount_application && a.discount_application.title;
        if (t && titles.indexOf(t) < 0) titles.push(t);
      });
    });
    if (cart.total_discount > 0) {
      els.discountTags.innerHTML = titles.map(function (t) { return '<span class="erl-cart__tag">' + TAG_SVG + esc(decode(t)) + '</span>'; }).join('');
      els.discountAmount.textContent = '- ' + money(cart.total_discount);
      els.discounts.hidden = false;
    } else {
      els.discounts.hidden = true;
    }
    els.checkout.innerHTML = 'Checkout &bull; ' + money(cart.total_price);
  }

  function refresh() {
    if (state.refreshing) {
      state.pending = state.pending || state.refreshing.then(function () { state.pending = null; return refresh(); });
      return state.pending;
    }
    state.refreshing = api('/cart.js')
      .then(function (cart) {
        return loadCompare(cart.items || []).then(function () { return cart; });
      })
      .then(function (cart) { render(cart); updateBubble(); return cart; })
      .catch(function (e) { console.error('[ERL cart]', e); })
      .finally(function () { state.refreshing = null; });
    return state.refreshing;
  }

  function updateBubble(sectionsHTML) {
    var apply = function (html) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = doc.querySelector('.shopify-section') || doc.body;
      bubble.innerHTML = sec.innerHTML;
    };
    if (sectionsHTML) return apply(sectionsHTML);
    nativeFetch('/?sections=cart-icon-bubble', { headers: { 'X-ERL-Cart': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { apply(d && d['cart-icon-bubble']); })
      .catch(function () {});
  }

  /* ---------- aantallen wijzigen ---------- */
  function change(key, qty) {
    var row = els.items.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (row) row.classList.add('is-loading');
    return api('/cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(function (res) {
        if (res && res.status && res.description) alert(res.description);
        return refresh();
      })
      .catch(function () { if (row) row.classList.remove('is-loading'); });
  }

  els.items.addEventListener('click', function (e) {
    var row = e.target.closest('.erl-cart__item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    if (e.target.closest('[data-erl-remove]')) { change(key, 0); return; }
    var btn = e.target.closest('[data-erl-qty]');
    if (btn) {
      var input = row.querySelector('[data-erl-qty-input]');
      change(key, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-erl-qty'), 10));
    }
  });
  els.items.addEventListener('change', function (e) {
    if (!e.target.matches('[data-erl-qty-input]')) return;
    var row = e.target.closest('.erl-cart__item');
    change(row.getAttribute('data-key'), parseInt(e.target.value, 10) || 0);
  });

  /* ---------- openen / sluiten ---------- */
  function open() {
    if (!state.open) {
      state.open = true;
      state.lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('erl-cart-lock');
      setTimeout(function () { try { els.panel.focus({ preventScroll: true }); } catch (e) {} }, 50);
    }
    startTimer();
    return refresh();
  }
  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('erl-cart-lock');
    stopTimer();
    if (state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-erl-close]');
    if (!c) return;
    if (c.tagName !== 'A') e.preventDefault();
    close();
  });
  els.checkout.addEventListener('click', function () { els.checkout.classList.add('is-loading'); });
  window.addEventListener('pageshow', function () { els.checkout.classList.remove('is-loading'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });

  /* Winkelwagen-icoon en /cart-links openen de drawer */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"], [data-erl-open]');
    if (!trigger || root.contains(trigger)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  /* ---------- thema-drawer koppelen aan onze drawer ---------- */
  function patchThemeDrawer() {
    var Ctor = window.customElements && customElements.get('cart-drawer');
    if (!Ctor || Ctor.prototype.__erlPatched) return;
    var proto = Ctor.prototype;
    proto.__erlPatched = true;
    proto.open = function () { open(); };
    proto.close = function () { close(); };
    proto.setActiveElement = function () {};
    proto.getSectionsToRender = function () { return [{ id: 'cart-icon-bubble' }]; };
    proto.renderContents = function (parsed) {
      if (parsed && parsed.sections && parsed.sections['cart-icon-bubble']) updateBubble(parsed.sections['cart-icon-bubble']);
      open();
    };
  }
  patchThemeDrawer();
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(patchThemeDrawer);

  /* ---------- andere add-to-cart knoppen (fetch / XHR) opvangen ---------- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function isOurs(init) {
    var h = init && init.headers;
    if (!h) return false;
    if (typeof h.get === 'function') return h.get('X-ERL-Cart') === '1';
    return h['X-ERL-Cart'] === '1';
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url) && !isOurs(init)) {
      p.then(function (r) {
        if (!r.ok) return;
        var isAdd = /\/cart\/add/.test(url);
        setTimeout(function () { isAdd ? open() : (state.open ? refresh() : updateBubble()); }, 0);
      }).catch(function () {});
    }
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__erlUrl = url;
    return xOpen.apply(this, arguments);
  };
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__erlUrl && CART_RE.test(xhr.__erlUrl)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          /\/cart\/add/.test(xhr.__erlUrl) ? open() : (state.open ? refresh() : updateBubble());
        }
      });
    }
    return xSend.apply(this, arguments);
  };

  /* ---------- start ---------- */
  setLogo();
  window.ERLCart = { open: open, close: close, refresh: refresh };
  document.dispatchEvent(new CustomEvent('erl:cart:ready'));
})();
